import React from 'react';
import { useMinimizableModal } from '../../controllers/use-minimizable-modal/index.tsx';
import type { ModalContainerProps, ModalHeaderProps } from '../../types.tsx';
import { FullscreenTransition } from './fullscreen-transition/index.tsx';
import { Fullscreen } from './fullscreen/index.tsx';
import { MiniTransition } from './mini-transition/index.tsx';
import { Mini } from './mini/index.tsx';
import { MinimizedTransition } from './minimized-transition/index.tsx';
import { Minimized } from './minimized/index.tsx';
import { ModalHeader, MiniHeader } from './modal-header/index.tsx';
import { ModalTransition } from './modal-transition/index.tsx';
import { Modal } from './modal/index.tsx';

const DefaultHeader = (props: ModalHeaderProps) => <ModalHeader {...props} />;
const DefaultMiniHeader = (props: ModalHeaderProps) => <MiniHeader {...props} />;

export const ModalContainer = ({ children, components }: ModalContainerProps) => {
	const { view } = useMinimizableModal();

	return (
		<>
			<ModalTransition renderCondition={view === 'modal'}>
				<Modal components={components || { Header: DefaultHeader }}>{children}</Modal>
			</ModalTransition>
			<MiniTransition renderCondition={view === 'mini'}>
				{({ transitionProps }) => (
					<Mini {...transitionProps} components={components || { Header: DefaultMiniHeader }}>
						{children}
					</Mini>
				)}
			</MiniTransition>
			<FullscreenTransition renderCondition={view === 'fullscreen'}>
				{({ transitionProps }) => (
					<Fullscreen {...transitionProps} components={components || { Header: DefaultMiniHeader }}>
						{children}
					</Fullscreen>
				)}
			</FullscreenTransition>
			<MinimizedTransition renderCondition={view === 'minimized'}>
				{({ transitionProps }) => <Minimized {...transitionProps} />}
			</MinimizedTransition>
		</>
	);
};
